export default __webpack_public_path__ + "static/media/problem-active.b82ab3d1.svg";